export default __webpack_public_path__ + "static/media/icon_calendar.9de12278.svg";